import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Discounts.css';

interface IDiscountsProps {
  discountCards: React.ReactNode;
  showMore: React.ReactNode;
}

export function Discounts({ discountCards, showMore }: IDiscountsProps) {
  return (
    <section id="discounts" className={styles['discounts']}>
      <Layout>
        <ul className={styles['discounts__list']}>
          {React.Children.map(discountCards, (card, index) => (
            <li key={index} className={styles['discounts__list-item']}>
              {card}
            </li>
          ))}
        </ul>

        <div className={styles['show']}>{showMore}</div>
      </Layout>
    </section>
  );
}
